import { th } from 'date-fns/locale';
import { JobCategory } from 'jobs/types';
import {
  action,
  computed,
  IReactionDisposer,
  makeAutoObservable,
  makeObservable,
  observable,
  reaction,
  runInAction,
} from 'mobx';
import { WorkTypes } from './brain/work-types_search.vm';
import { CandidateEditProfileEmpty, Position } from 'candidate/types';
import { CandidateApiService } from 'candidate/CandidateApiService';
import { debounce } from 'lodash';
import { AxiosError } from 'axios';
export class DesiredPositionStore {
  valid: boolean = false;
  position: string = '';
  postionSearh: string = '';
  readonly positionOptions = observable.array<Position>([]);
  private disposer: IReactionDisposer;
  readonly workTypes = new WorkTypes();
  constructor() {
    makeObservable(this, {
      valid: observable,
      position: observable,
      onSearchPosition: action.bound,
    });

    const debouncedFetch = debounce((query: string) => {
      this.getPositions(query);
    }, 500);

    this.disposer = reaction(
      () => this.position,
      (q) => debouncedFetch(q)
    );

    reaction(
      () => this.positionOptions,
      () => {
        console.log(this.positionOptions, 'OPT');
      }
    );
  }

  private getPositions = async (query: string): Promise<void> => {
    if (query.length < 2) {
      return;
    }
    try {
      const resp = await CandidateApiService.getPositions({
        query,
      });
      if (resp.status === 200) {
        runInAction(() => {
          this.positionOptions.replace(resp.response);
        });
      }
    } catch (e) {
      runInAction(() => {
        console.log('fire ERROT EMPTY');
        this.positionOptions.replace([]);
      });
    }
  };

  onSearchPosition(query: string) {
    this.positionOptions.clear();

    this.position = query;
  }

  update({ work_types }: CandidateEditProfileEmpty): void {
    this.workTypes.set(work_types);
  }

  dispose(): void {
    this.disposer();
  }
}
